/**
 * The public pages the website draft covers.
 *
 * `MarketingSurface` reads this to switch a page to the draft's typeface. The
 * footer no longer does: every page outside admin gets the same one, so a route
 * missing from this list costs the typeface only, not the site's chrome.
 */
const MARKETING_ROUTES = new Set([
  "/",
  "/concept",
  // Both the canonical paths and the legacy aliases that redirect to them
  // (COL-464): a visitor can land on either, and neither the footer nor the
  // typeface should flip mid-redirect.
  "/rooms",
  "/properties",
  "/community",
  "/careers",
  "/contact",
  "/owners",
  "/operators",
  "/developers",
  // The free-tier owner acquisition flow. These are public, pre-auth pages
  // drawn from the same website draft as /owners — the CTA that reaches them
  // is ON /owners — so the app footer and Inter under them read as a different
  // site mid-signup. Listed as a whole flow, not just the entry point: the
  // footer and typeface must not flip between typing an e-mail and confirming
  // it, for the same reason the legacy aliases above are listed.
  "/owners/signup",
  "/owners/verify",
  "/owners/confirmed",
  "/imprint",
  "/privacy-policy",
  "/terms-of-service",
]);

// `/r/CODE` is the referral link into /owners/signup — same page, same chrome.
const MARKETING_PREFIXES = ["/rooms/", "/properties/", "/property/", "/r/"];

export function isMarketingRoute(pathname: string): boolean {
  return (
    MARKETING_ROUTES.has(pathname) ||
    MARKETING_PREFIXES.some((prefix) => pathname.startsWith(prefix))
  );
}
